/* eslint-disable @typescript-eslint/naming-convention */
/* eslint-disable react/no-danger */
import type { ReactElement } from 'react';

import { ThemeProvider } from '@mui/material/styles';
import Typography from '@mui/material/Typography';

import { useGlobalState } from '../../../../../global_state/src';

interface ThemedProgressDialogMessageProps {
    /** Array of messages, you can add <html> elements directly into the string for easy formatting like <strong> */
    messages?: Array<string>;
}

const ThemedProgressDialogMessage = ({
    messages,
}: ThemedProgressDialogMessageProps): ReactElement | null => {
    const [theme] = useGlobalState('theme');

    if (!messages) {
        return null;
    }

    return (
        <ThemeProvider theme={theme}>
            {messages.length > 1 && (
                <Typography variant="captions.default">
                    <ul
                        style={{
                            paddingLeft: theme.spacing(4),
                            marginBlock: 0,
                        }}
                    >
                        {messages.map((message) => (
                            <li
                                key={message}
                                style={{ marginBlockEnd: theme.spacing(1) }}
                                dangerouslySetInnerHTML={{ __html: message }}
                            />
                        ))}
                    </ul>
                </Typography>
            )}
            {messages.length === 1 && (
                <Typography
                    variant="captions.default"
                    sx={{
                        textAlign: 'center',
                    }}
                >
                    <span dangerouslySetInnerHTML={{ __html: messages[0] }} />
                </Typography>
            )}
        </ThemeProvider>
    );
};

export { ThemedProgressDialogMessage };
export type { ThemedProgressDialogMessageProps };
